import {makeStyles} from '@material-ui/core/styles'
import { createMuiTheme } from '@material-ui/core';
import { colores, tipografia } from 'AppStyle'

export const customStyle = makeStyles ({

    gridMenu:{
        width: 'fit-content',
        marginRight: '5%'
    },
    appBar:{
        boxShadow: 'none',
        backgroundColor: 'transparent'
    },
    tabs:{
        //fontFamily: $´{tipografia.medium}!important´, //NO LO  COCGE
        color: colores.escalaGrises.cien,
    },
    tab:{
        fontSize: '14px',
        lineHeight: '16px',
        color: 'inherit',
        minWidth: '110px',  
        opacity:'0.9',
        alignItems: 'start'
    },
    tabIcon:{
        height: '24px', 
    },
    //Inserta una imagen al producirse el evento hover
    classIcon: {
        height:'24px',  
        filter: 'invert(91%) sepia(26%) saturate(150%) hue-rotate(77deg) brightness(90%) contrast(92%)',
        '&:hover': {
          filter:'invert(30%) sepia(20%) saturate(3452%) hue-rotate(96deg) brightness(94%) contrast(94%)'
        }
    }
})

export const overrideStyle = createMuiTheme({
    overrides: {
        MuiTab:{
            root:{
                textTransform: 'none',
                fontFamily: `${tipografia.medium}!important`,
            },
            textColorInherit:{
                maxWidth: '110px',
                minWidth: '30px'
            },
            wrapper:{
                fontFamily: tipografia.medium
            }
        },
        MuiTabs:{
            indicator:{
                backgroundColor: colores.principales.principal
            }
        },
        MuiAppBar:{
            colorPrimary:{
                backgroundColor: colores.escalaGrises.cero
            },
            root:{
                zIndex: 0
            }
        }
    }
})